const baseUrl =
  process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BASE_URL;
const authorizationPrefix = 'Bearer';

export { authorizationPrefix, baseUrl };
